// extracted by mini-css-extract-plugin
module.exports = {"label":"_373a3719ba--label--hIfaq","cursor_pointer":"_373a3719ba--cursor_pointer--Pe1mY"};